import Immutable from 'immutable';
import moment from 'moment';
const LOAD = 'futurecare/LOAD';
const LOAD_SUCCESS = 'futurecare/LOAD_SUCCESS';
const LOAD_FAIL = 'futurecare/LOAD_FAIL';
const FUTURE_CARE_SUCCESS = 'futurecare/FUTURE_CARE_SUCCESS';
const FUTURE_CARE_LOAD = 'futurecare/FUTURE_CARE_LOAD';
const FUTURE_CARE_FAIL = 'futurecare/FUTURE_CARE_FAIL';
const FC_LAST_MONTHS_SUCCESS = 'futurecare/FC_LAST_MONTHS_SUCCESS';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  billingData: null,
  isFutureLoad: false,
  futureLoadErr: null,
  futureCareData: null,
  fcLastMonthsData: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('isFutureLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('billingData', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('billingData', null);
    case FUTURE_CARE_LOAD:
      return state
        .set('isFutureLoad', true)
        .set('futureLoadErr', null);

    case FUTURE_CARE_SUCCESS:
      return state
        .set('isFutureLoad', false)
        .set('futureLoadErr', null)
        .set('futureCareData', action.res);

    case FUTURE_CARE_FAIL:
      return state
        .set('isFutureLoad', false)
        .set('futureLoadErr', action.error)
        .set('futureCareData', null);

    case FC_LAST_MONTHS_SUCCESS:
      return state
      .set('fcLastMonthsData', action.res);

    default:
      return state;
  }
};


export const getBillingData = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let fcrParams = Object.assign({}, params);
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/futurecare${params}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    if(res.bCPV) {
      fcrParams.avgBCare = res.ADbC;
    }
    fcrParams.startDate = moment(fcrParams.startDate).add(1, 'year').format('Y-MM-01');
    fcrParams.endDate = moment(fcrParams.startDate).endOf('month').format('Y-MM-DD');

    fcrParams = '/'+JSON.stringify(fcrParams);
    dispatch(getFutureCareDetails(fcrParams));
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getFutureCareDetails = (params) => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`udr/futurecareDetails${params}`);
    dispatch({ type: FUTURE_CARE_SUCCESS, res: res });
    dispatch(getLockLogsHistory(params));
    dispatch(getFcLastMonthsData(params));
  } catch (err) {
    dispatch({ type: FUTURE_CARE_FAIL, error: err.message });
  }
};

export const getLockLogsHistory = (params) => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`udr/getLockLogsHistory${params}`);
    let futureCareData = getState().get('futurecare').get('futureCareData');
    if(futureCareData && Object.keys(futureCareData).length) {
      futureCareData.lockLogs = res;
      dispatch({ type: FUTURE_CARE_SUCCESS, res: futureCareData });
    }
  } catch (err) {
    dispatch({ type: FUTURE_CARE_FAIL, error: err.message });
  }
};

export const getFcLastMonthsData = (params, recall = true) => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`udr/futurecareOldDetails${params}`);
    dispatch({ type: FC_LAST_MONTHS_SUCCESS, res: res });
    if(res.needToUpdate) {
      if(recall)
        dispatch(updateFcLastMonthsData(params));
    }
  } catch (err) {
    dispatch({ type: FUTURE_CARE_FAIL, error: err.message });
  }
};

export const updateFcLastMonthsData = (params) => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`udr/updateFcLastMonthsData${params}`);
    dispatch(getFcLastMonthsData(params, false));
    return res;
  } catch (err) {
    dispatch({ type: FUTURE_CARE_FAIL, error: err.message });
  }
};

export const saveFutureCareStatus = (params) => async (dispatch, getState, api) => {
  dispatch({ type: FUTURE_CARE_LOAD });
  try {
    let res = await api.post(`udr/futurecareDetails`, {data:params});
    dispatch({ type: FUTURE_CARE_SUCCESS, res: res });
    if(params.type === 'locked') {
      const param = '/'+JSON.stringify({ startDate: params.scheduleDate, billingPractices: params.practice });
      dispatch(getLockLogsHistory(param));
    }
  } catch (err) {
    dispatch({ type: FUTURE_CARE_FAIL, error: err.message });
  }
};
